import { ExtendedLinkType } from "@/components/ExtededLink/ExtendedLink";
import { LinkType } from "@/types/baseTypes";

export type BoxPaddingType = {
  mobile: string;
  tablet: string;
  desktop: string;
  fullhd: string;
};

export const getBoxPadding = (box_padding: BoxPaddingType) => {
  return {
    "--box-padding-mobile": box_padding.mobile.replaceAll(",", "."),
    "--box-padding-tablet": box_padding.tablet.replaceAll(",", "."),
    "--box-padding-desktop": box_padding.desktop.replaceAll(",", "."),
    "--box-padding-fullhd": box_padding.fullhd.replaceAll(",", "."),
  };
};

export function replaceExtendedLinkText(
  text: string,
  extendedLink: ExtendedLinkType,
): ExtendedLinkType {
  const newExtendedLink = { ...extendedLink };
  const { type } = extendedLink;
  switch (type) {
    case "email":
      newExtendedLink.email.link_text = text;
      break;
    case "download":
      newExtendedLink.download.link_text = text;
      break;
    case "link":
      if (newExtendedLink.link) {
        newExtendedLink.link.title = text;
      }
      break;
    case "popup":
      newExtendedLink.pop_up.link_text = text;
      break;
  }
  return newExtendedLink;
}

export function checkLinkAvailable(
  link: LinkType | ExtendedLinkType | false,
  show_extended_link: boolean,
): boolean {
  if (!link) return false;
  if (show_extended_link) {
    const extendedLink = link as ExtendedLinkType;
    const { type } = extendedLink;
    switch (type) {
      case "email":
        return !!extendedLink.email?.link_target;
      case "download":
        return !!extendedLink.download?.link_target;
      case "link":
        return !!(extendedLink.link && extendedLink.link?.url);
      case "popup":
        return !!extendedLink.pop_up;
      default:
        return false;
    }
  } else {
    const normalLink = link as LinkType;
    return !!(normalLink && normalLink.url);
  }
}

export const getShowBoxClasses = (
  effectiveShowCardbox: boolean,
  effectiveShowDivider: boolean,
  show_border_radius: boolean,
  show_box_shadow: boolean,
): string => {
  return effectiveShowCardbox && !effectiveShowDivider
    ? `${effectiveShowCardbox ? "is-box h-100" : ""} ${
        show_border_radius ? "has-border-radius" : ""
      } ${show_box_shadow ? "has-box-shadow" : ""}`
    : "";
};
